import { Box, Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const PaperWrapper = styled(Box)(({ theme }) => ({
  marginTop: 16,
  maxWidth: '95%',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 32,
  paddingBottom: 32,
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow:
    '0px 2px 4px -1px #e0e0e0, 0px 4px 5px 0px #bdbdbd, 0px 1px 10px 0px #9e9e9e',
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  boxSizing: 'border-box'
}));

const ControlsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  width: '50%'
}));

const RightActionsRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
  width: '100%'
}));

const TableHeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1)
}));

const GridContainer = styled(Box)(() => ({
  width: '100%'
}));

const DialogActionsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1)
}));

const FormColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2)
}));

const FormHeader = styled(Typography)(() => ({
  marginLeft: '48px',
  fontWeight: 600
}));

const StyledTextField = styled(TextField)(() => ({
  marginTop: '16px'
}));

const ActionButton = styled(Button)(() => ({
  marginRight: '8px'
}));

const AcademicYearContainer = styled(Box)(() => ({
  marginTop: '32px'
}));

export {
  ControlsRow,
  RightActionsRow,
  TableHeaderRow,
  ActionButton,
  GridContainer,
  DialogActionsRow,
  FormColumn,
  FormHeader,
  StyledTextField,
  AcademicYearContainer,
  PaperWrapper
};
